"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var timepicker = process.env.NODE_ENV === "production" ? {
  name: "1ah46xy",
  styles: "-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;font-family:'Roboto',sans-serif;background:white;border-radius:3px;display:inline-block;box-shadow:0 3px 11px rgba(0,0,0,0.1),0 3px 6px rgba(0,0,0,0.15);width:260px;position:relative;user-select:none;"
} : {
  name: "1ah46xy",
  styles: "-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;font-family:'Roboto',sans-serif;background:white;border-radius:3px;display:inline-block;box-shadow:0 3px 11px rgba(0,0,0,0.1),0 3px 6px rgba(0,0,0,0.15);width:260px;position:relative;user-select:none;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9tYWluLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVzQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zdHlsZXMvbWFpbi50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcblxuY29uc3QgdGltZXBpY2tlciA9IGNzc2Bcblx0LXdlYmtpdC10YXAtaGlnaGxpZ2h0LWNvbG9yOiB0cmFuc3BhcmVudDtcblx0LXdlYmtpdC1mb250LXNtb290aGluZzogYW50aWFsaWFzZWQ7XG5cdGZvbnQtc21vb3RoaW5nOiBhbnRpYWxpYXNlZDtcblxuXHRmb250LWZhbWlseTogJ1JvYm90bycsIHNhbnMtc2VyaWY7XG5cdGJhY2tncm91bmQ6IHdoaXRlO1xuXHRib3JkZXItcmFkaXVzOiAzcHg7XG5cdGRpc3BsYXk6IGlubGluZS1ibG9jaztcblx0Ym94LXNoYWRvdzogMCAzcHggMTFweCByZ2JhKDAsIDAsIDAsIDAuMSksIDAgM3B4IDZweCByZ2JhKDAsIDAsIDAsIDAuMTUpO1xuXHR3aWR0aDogMjYwcHg7XG5cdHBvc2l0aW9uOiByZWxhdGl2ZTtcblx0dXNlci1zZWxlY3Q6IG5vbmU7XG5gXG5cbmV4cG9ydCBkZWZhdWx0IHRpbWVwaWNrZXJcbiJdfQ== */"
};
var _default = timepicker;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-timekeeper/lib/components/styles/main.js
// module id = 6312
// module chunks = 39